// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import * as echarts from 'echarts';
import VueHotkey from 'v-hotkey';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/default.scss';
import './assets/fonts/fonts.css'



import App from './App';
import store from './store';
import router from './router';
import settings from './settings';
import { Base64 } from 'js-base64';
import {checkTokenExpire} from './common/common';

Vue.prototype.checkTokenExpire = checkTokenExpire;
Vue.prototype.Base64 = Base64;
Vue.prototype.settings = settings;
Vue.prototype.$echarts = echarts;
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
};

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
};


Vue.use(ElementUI);
Vue.use(VueHotkey);

Vue.directive('focus', function (el,evt) {
  let oinput = el.querySelector('input');
  if(evt.value) {
    oinput.focus();
  }
});

// 启动 mock
if (process.env.NODE_ENV === 'development'){
  const { mockApi } = require('../mock');
  mockApi();
}


// 设置路由跳转的逻辑
router.beforeEach((to, from, next) => {
  if (to.matched.length !== 0) {
    next()
  } else {
    next({ path: 'index' })
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js